import React from "react";
import Box from "../layout/Box";
import Transactions from "./Transactions";

export default function TransactionsPage() {
  return (
    <Box title={"transactions"} centerContent={true}>
      <Transactions />
    </Box>
  );
}
